module.exports = __webpack_public_path__ + "img/planet-uranus-geology.135c195e.png";